module.exports = __webpack_public_path__ + "images/lapdance-lover-44aa61bf73262112f92a7fecbfac856c.png";